// 系统设置路由
const settingRouter = {
  path: 'setting',
  name: 'setting',

  component: { render: h => h('router-view') },
  children: [
    {
      path: 'business-type',
      name: 'business-type',
      component: () => import('views/setting/business-type'),
    },
    {
      path: 'region',
      name: 'region',
      component: () => import('views/setting/region'),
    },
    //segment设置
    {
      path: 'segment',
      name: 'segment',
      component: () => import('views/setting/segment'),
    },
    //汇率转化设置
    {
      path: 'exchange-rate',
      name: 'exchange-rate',
      component: () => import('views/setting/exchange-rate'),
    },
    //初始化
    {
      path: 'initialization',
      name: 'initialization',
      component: () => import('views/setting/initialization'),
    },
    // 自定义评分卡
    {
      path: 'custom-card',
      name: 'custom-card',
      component: () => import('views/setting/custom-card'),
    },
    // 风险系数设置
    {
      path: 'custom-grading',
      name: 'custom-grading',
      component: () => import('views/setting/custom-grading'),
    },
    // 自动审核约束条件
    {
      path: 'custom-examine',
      name: 'custom-examine',
      component: () => import('views/setting/custom-examine'),
    },
    // 信用额度申请邮件审批邮箱设置
    {
      path: 'email-settings',
      name: 'email-settings',
      component: () => import('views/setting/email-settings'),
    },
    {
      path: 'business-mode-setting',
      name: 'business-mode-setting',
      component: () => import('views/setting/business-mode-setting'),
    },
    {
      path: 'xkq-setting',
      name: 'xkq-setting',
      component: () => import('views/setting/xkq-setting'),
    },
    {
      path: 'score-card',
      name: 'score-card',
      component: () => import('views/setting/score-card'),
    },
    {
      path: 'parameter-configuration',
      name: 'parameter-configuration',
      component: () => import('views/setting/parameter-configuration'),
    },
    //  担保审批人设置
    {
      path: 'guarantee-approver',
      name: 'guarantee-approver',
      component: () => import('views/setting/guarantee-approver'),
    },
    // 风险标签设置
    {
      path: 'risk-label',
      name: 'risk-label',
      component: () => import('views/setting/risk-label'),
    },
    // 预警信息设置
    {
      path: 'early-warning-rules',
      name: 'early-warning-rules',
      component: () => import('views/setting/early-warning-rules'),
    },
    // 内外部评级转换规则设置
    {
      path: 'credit-rating-conversion',
      name: 'credit-rating-conversion',
      component: () => import('views/setting/credit-rating-conversion'),
    },
    {
      path: 'file-management/flow',
      name: 'file-management-flow',
      component: () => import('views/setting/file-management-flow'),
    },
    {
      path: 'file-management/policy',
      name: 'file-management-policy',
      component: () => import('views/setting/file-management-policy'),
    },
    {
      path: 'file-management/template',
      name: 'file-management-template',
      component: () => import('views/setting/file-management-template'),
    },
    {
      path: 'file-management/training',
      name: 'file-management-training',
      component: () => import('views/setting/file-management-training'),
    },
    {
      path: 'indicator-warning',
      name: 'indicator-warning',
      component: () => import('views/setting/indicator-warning'),
    },
    {
      path: 'page-setting',
      name: 'page-setting',
      component: () => import('views/setting/page-setting'),
    },
    {
      path: 'legal-entity-setting',
      name: 'legal-entity-setting',
      component: () => import('views/setting/legal-entity-setting'),
    },
    {
      path: 'country-level',
      name: 'country-level',
      component: () =>
        import(
          /* webpackChunkName: "country-level" */ 'views/setting/country-level'
        ),
    },
    {
      path: 's4',
      name: 's4',
      component: () => import(/* webpackChunkName: "s4" */ 'views/setting/s4'),
    },
    // 自定义评分卡指标维护
    {
      path: 'custom-target-maintenance',
      name: 'custom-target-maintenance',
      component: () => import('views/setting/custom-target-maintenance'),
    },
    // 标准账期设置
    {
      path: 'custom-account-period',
      name: 'custom-account-period',
      component: () => import('views/setting/custom-account-period'),
    },
  ],
}

export default settingRouter
